import {
  CompanyMessageInfo,
  IMessageItem,
  IMessageServiceOpen,
  MessageSubType,
  PermissionMessageData,
  PermissionMessageInfo,
} from '../../../model/api-modules';
import { RoleGroupType } from '../../../model/rbac';
import { getCustomReason } from './config';
import { Preview } from '../preview';
import getFormatMessage from '../../../locales/get-format-message';
import {
  getFormatDateTime,
  getLocaleLanguage,
  getLocalTime,
  LanguageType,
} from '../../../lib';

export const getContentByMessage = (
  message: IMessageItem,
  previewStyle = {
    fontSize: 'var(--font-size-mdm)',
    color: 'var(--color-text-tertiary)',
  },
  previewClassName?: string
) => {
  /* eslint-disable */
  const { StudioName, StudioID, SubType, Content, ModifyTime } = message;
  const dateTime = getFormatDateTime(ModifyTime);
  const formattedDate = dateTime.substring(0, 10);
  const studioStr = `${StudioName}(${StudioID})`;
  let serviceObj = { ServiceName: '', GameName: '', EnvName: '' };
  const currentLanguage = getLocaleLanguage() || LanguageType.en_US;
  const lineBreak = currentLanguage === LanguageType.zh_CN ? <br /> : null;
  const messageUser = getFormatMessage('respect_user');
  const studioContent = getFormatMessage('studio_name_and_id', {
    params: {
      studioStr,
    },
  });
  if (
    [
      MessageSubType.ServiceOpenSuccess,
      MessageSubType.ServiceOpenFail,
    ].includes(SubType)
  ) {
    try {
      serviceObj = JSON.parse(message.Content || '{}');
    } catch (error) {}
  }
  switch (message.SubType) {
    case MessageSubType.PermissionUp:
    case MessageSubType.PermissionDown:
      const messageContent = getFormatMessage(
        'owner_transfer_notification_content',
        {
          params: {
            // studioStr: studioStr,
            authority: getCustomReason(SubType, Content),
          },
        }
      );
      return (
        <>
          {/* {messageUser} */}
          {studioContent}
          <br />
          {messageContent}
        </>
      );

    case MessageSubType.MemberPermissionChange:
      let contentMemberPermChange: PermissionMessageInfo | string = Content;
      try {
        contentMemberPermChange = JSON.parse(Content);
      } catch (error) {}
      if (
        contentMemberPermChange instanceof Object &&
        contentMemberPermChange.authType === RoleGroupType.Role
      ) {
        return (
          <>
            {studioContent} <br />
            {getFormatMessage('permission_change_become_admin_content')}
          </>
        );
      }
      return (
        <>
          {studioContent} <br />
          {getFormatMessage('permission_change_content')}
        </>
      );
    case MessageSubType.PermissionUserGroupJoin:
    case MessageSubType.PermissionUserGroupRemove:
      let contentUserGroup: PermissionMessageInfo | string = Content;
      try {
        contentUserGroup = JSON.parse(Content);
      } catch (error) {}

      return (
        <>
          {typeof contentUserGroup == 'object' &&
          Object.prototype.toString.call(contentUserGroup).toLowerCase() ==
            '[object object]' ? (
            <>
              {studioContent}
              <br />
              {getFormatMessage('permission_change_user_groups_content', {
                params: {
                  action: getCustomReason(SubType, Content),
                  changeDate: formattedDate,
                  groups: getChangeGroupsText(contentUserGroup?.data),
                },
              })}
            </>
          ) : (
            `${contentUserGroup}`
          )}
        </>
      );
    case MessageSubType.PermissionChange:
      let contentPermission: PermissionMessageInfo | string = Content;
      try {
        contentPermission = JSON.parse(Content);
      } catch (error) {}
      return (
        <>
          {typeof contentPermission == 'object' &&
          Object.prototype.toString.call(contentPermission).toLowerCase() ==
            '[object object]' ? (
            <>
              {studioContent}
              <br />
              {getFormatMessage('group_permission_change_content', {
                params: {
                  changeDate: formattedDate,
                  groups: getChangeGroupsText(contentPermission?.data),
                },
              })}
            </>
          ) : (
            `${contentPermission}`
          )}
        </>
      );
    case MessageSubType.PermissionScopeChange:
      let contentScope: PermissionMessageInfo | string = Content;
      try {
        contentScope = JSON.parse(Content);
      } catch (error) {}
      return (
        <>
          {typeof contentScope == 'object' &&
          Object.prototype.toString.call(contentScope).toLowerCase() ==
            '[object object]' ? (
            <>
              {studioContent}
              <br />
              {getFormatMessage('group_scope_change_content', {
                params: {
                  changeDate: formattedDate,
                  groups: getChangeGroupsText(contentScope?.data),
                },
              })}
            </>
          ) : (
            `${contentScope}`
          )}
        </>
      );
    // 删除工作室
    case MessageSubType.PermissionStudioDelete:
      return (
        <>
          {studioContent}
          <br />
          {getFormatMessage('permission_studio_delete_content', {
            params: {
              studioName: StudioName,
              deletionDate: formattedDate,
            },
          })}
        </>
      );
    case MessageSubType.PermissionGameDelete:
      let contentDelGame:
        | {
            gameName: string;
          }
        | string = Content;
      try {
        contentDelGame = JSON.parse(Content);
      } catch (error) {}
      return (
        <>
          {typeof contentDelGame == 'object' &&
          Object.prototype.toString.call(contentDelGame).toLowerCase() ==
            '[object object]' ? (
            <>
              {studioContent}
              <br />
              {getFormatMessage('permission_game_delete_content', {
                params: {
                  gameName: contentDelGame?.gameName,
                  deletionDate: formattedDate,
                },
              })}
            </>
          ) : (
            `${contentDelGame}`
          )}
        </>
      );
    case MessageSubType.PermissionEnvDelete:
      let contentDelEnv:
        | {
            envName: string;
          }
        | string = Content;
      try {
        contentDelEnv = JSON.parse(Content);
      } catch (error) {}
      return (
        <>
          {typeof contentDelEnv == 'object' &&
          Object.prototype.toString.call(contentDelEnv).toLowerCase() ==
            '[object object]' ? (
            <>
              {studioContent}
              <br />
              {getFormatMessage('permission_env_delete_content', {
                params: {
                  envName: contentDelEnv?.envName,
                  deletionDate: formattedDate,
                },
              })}
            </>
          ) : (
            `${contentDelEnv}`
          )}
        </>
      );
    case MessageSubType.MemberAppJoinFor:
      let content:
        | {
            Applicant: string;
            ApplicantUserID: String;
            Reason: string;
          }
        | string = Content;
      try {
        content = JSON.parse(Content);
      } catch (error) {}
      return (
        <>
          {typeof content == 'object' &&
          Object.prototype.toString.call(content).toLowerCase() ==
            '[object object]' ? (
            <>
              {messageUser}
              {lineBreak}
              {getFormatMessage('has_join_organization_reason_desc1', {
                params: {
                  studioStr: studioStr,
                  applicant:
                    content?.Applicant ||
                    content?.ApplicantUserID?.split('@')?.[0] ||
                    '',
                  applicantUserID: content?.ApplicantUserID,
                },
              })}
              {lineBreak}
              {getFormatMessage('has_join_organization_reason_desc2')}
              {content?.Reason}
              {lineBreak}
              {getFormatMessage('go_to_join_organization_page_handle')}
            </>
          ) : (
            `${content}`
          )}
        </>
      );
    case MessageSubType.MemberAppJoinSuccess:
      const memberAppJoinSuccessContent = getFormatMessage(
        'application_approved_message',
        {
          params: { studioStr: studioStr },
        }
      );
      return (
        <>
          {messageUser}
          {lineBreak}
          {memberAppJoinSuccessContent}
        </>
      );
    case MessageSubType.MemberAppJoinReject:
      const memberAppJoinRejectContent = getFormatMessage(
        'application_rejected_message',
        {
          params: { studioStr: studioStr },
        }
      );
      return (
        <>
          {messageUser}
          {lineBreak}
          {memberAppJoinRejectContent}
        </>
      );
    case MessageSubType.PermissionRemove:
      const permissionRemoveContent = getFormatMessage(
        'regret_inform_remove_message',
        {
          params: { studioStr: studioStr },
        }
      );
      return (
        <>
          {messageUser}
          {lineBreak}
          {permissionRemoveContent}
        </>
      );
    case MessageSubType.AdminInviteMemberSuccess:
      const adminInviteMemberSuccessContent = getFormatMessage(
        'admin_invite_member_success',
        {
          params: { studioStr: studioStr },
        }
      );
      return (
        <>
          {messageUser}
          {lineBreak}
          {adminInviteMemberSuccessContent}
        </>
      );
    case MessageSubType.VoluntarilyQuit:
      const voluntarilyQuitContent = getFormatMessage('success_exited_studio', {
        params: { studioStr: studioStr },
      });
      return (
        <>
          {messageUser}
          {lineBreak}
          {voluntarilyQuitContent}
        </>
      );
    case MessageSubType.ServiceOpenSuccess:
      const messageServiceOpenSuccessOne = getFormatMessage(
        'service_open_success_inform1',
        {
          params: {
            serviceName: serviceObj?.ServiceName,
            envName: serviceObj?.EnvName || '',
            gameName: serviceObj?.GameName,
          },
        }
      );
      const messageServiceOpenSuccessTwo = getFormatMessage(
        'service_open_success_inform2'
      );
      const messageServiceOpenSuccessThree = getFormatMessage(
        'service_open_success_inform3'
      );
      return (
        <>
          {messageUser}
          {lineBreak}
          {messageServiceOpenSuccessOne}
          {lineBreak}
          {messageServiceOpenSuccessTwo}
          {lineBreak}
          {messageServiceOpenSuccessThree}
        </>
      );
    case MessageSubType.ServiceOpenFail:
      const messageServiceOpenFailOne = getFormatMessage(
        'service_open_fail_inform1',
        {
          params: {
            serviceName: serviceObj?.ServiceName,
            envName: serviceObj?.EnvName || '',
            gameName: serviceObj?.GameName,
          },
        }
      );
      const messageServiceOpenFailOneTwo = getFormatMessage(
        'service_open_fail_inform2'
      );
      return (
        <>
          {messageUser}
          {lineBreak}
          {messageServiceOpenFailOne}
          {lineBreak}
          {messageServiceOpenFailOneTwo}
        </>
      );
    case MessageSubType.CompanyCertifiedSuccess: {
      let contentObj: CompanyMessageInfo | null = null;
      try {
        contentObj = JSON.parse(Content);
      } catch (error) {}
      if (contentObj) {
        return (
          <>
            {studioContent}
            <br />
            {getFormatMessage('company_authentication_success_content')}
          </>
        );
      }
      return '';
    }
    case MessageSubType.FeeCenterBalanceAlert: {
      return (
        <>
          {studioContent}
          <br />
          {getFormatMessage('account_balance_warm', {
            params: {
              createTime: getLocalTime(ModifyTime),
            },
          })}
        </>
      );
    }
    case MessageSubType.ServiceSubmitOpenApplySchedule: {
      return getServiceProgressNoticeBody(
        Content,
        'service_apply_pending_content'
      );
    }
    case MessageSubType.ServiceOpenSuccessSchedule: {
      return getServiceProgressNoticeBody(
        Content,
        'service_apply_success_content'
      );
    }
    case MessageSubType.ServiceOpenFailSchedule: {
      return getServiceProgressNoticeBody(
        Content,
        'service_apply_reject_content'
      );
    }

    case MessageSubType.CompanyCertifiedFail: {
      let contentObj: CompanyMessageInfo | null = null;
      try {
        contentObj = JSON.parse(Content);
      } catch (error) {}
      if (contentObj) {
        return (
          <>
            {studioContent}
            <br />
            {getFormatMessage('company_authentication_fail_content')}
          </>
        );
      }
      return '';
    }
    default:
      return (
        <Preview
          className={previewClassName}
          style={previewStyle}
          value={Content}
        />
      );
  }
};

export function getChangeGroupsText(data: PermissionMessageData) {
  return data
    ?.map((item) => {
      return item.groupName;
    })
    .join(', ');
}

function getServiceProgressNoticeBody(Content: string, key: string) {
  let contentObj: IMessageServiceOpen[] | null = null;
  try {
    contentObj = JSON.parse(Content);
  } catch (error) {}
  if (!contentObj || !(contentObj instanceof Array)) {
    return '';
  }
  return (
    <span
      dangerouslySetInnerHTML={{
        __html: getFormatMessage(key, {
          params: {
            content: contentObj
              .map(
                (contentItem, index) =>
                  `${index + 1}. ${getFormatMessage(
                    'service_apply_inner_service',
                    {
                      params: contentItem,
                    }
                  )};`
              )
              .join('<br />'),
          },
        }),
      }}
    ></span>
  );
}
